import { DownOutlined } from "@ant-design/icons";
import { Badge, Button, Dropdown, Menu, Typography } from "antd";
import { SELLER_ACCESS_STATUS } from "features/Agent/constants";
import { t } from "i18next";

const PRIMARY_COLOR = "#2246DC";

const EDITABLE_STATUSES = [SELLER_ACCESS_STATUS.ALLOWED, SELLER_ACCESS_STATUS.RESTRICTED];

const getStatusLabel = (status) => {
  switch (status) {
    case SELLER_ACCESS_STATUS.ALLOWED:
      return t("v2.seller.access_status.allowed");
    case SELLER_ACCESS_STATUS.RESTRICTED:
      return t("v2.seller.access_status.restricted");
    case SELLER_ACCESS_STATUS.TEMPORARY_ACTIVATED:
      return t("v2.seller.access_status.temporary_activated");
    default:
      return;
  }
};

function AccessStatusCell({ status, canUpdate, onChange }) {
  if (status === SELLER_ACCESS_STATUS.TEMPORARY_ACTIVATED) {
    return (
      <Badge
        color={PRIMARY_COLOR}
        text={
          <Typography.Text style={{ color: PRIMARY_COLOR, fontSize: 14 }}>{getStatusLabel(status)}</Typography.Text>
        }
      />
    );
  }

  // Unknown status: do not let staff change access based on a guessed value
  if (!EDITABLE_STATUSES.includes(status)) {
    return <Typography.Text style={{ color: "#9CADC4" }}>--</Typography.Text>;
  }

  if (!canUpdate) {
    return <Typography.Text>{getStatusLabel(status)}</Typography.Text>;
  }

  return (
    <Dropdown
      trigger={["click"]}
      overlay={
        <Menu onClick={({ key }) => onChange(key)}>
          {EDITABLE_STATUSES.map((item) => (
            <Menu.Item key={item} disabled={item === status}>
              {getStatusLabel(item)}
            </Menu.Item>
          ))}
        </Menu>
      }
    >
      <Button className="dropdown-action-contact">
        {getStatusLabel(status)} <DownOutlined />
      </Button>
    </Dropdown>
  );
}

export default AccessStatusCell;
